import api from '../api';
import axios from 'axios';
export default {
    CREATE_DRAFT: (data) => {
        return new Promise((resolve, reject) => {
            axios
                .post(process.env.REACT_APP_BACKEND_URL + api.draft.CREATE_DRAFT(), data)
                .then((response) => resolve(response))
                .catch((err) => reject(err));
        });
    },
    GET_ALL_DRAFT: () => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.draft.GET_ALL_DRAFT())
                .then((res) => resolve(res?.data?.data))
                .catch((err) => reject(err));
        });
    },
    DELETE_BY_ID_DRAFT: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .delete(process.env.REACT_APP_BACKEND_URL + api.draft.DELETE_BY_ID_DRAFT(id))
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },
    UPDATE_DRAFT: (id, data) => {
        return new Promise((resolve, reject) => {
            axios
                .put(process.env.REACT_APP_BACKEND_URL + api.draft.UPDATE_DRAFT(id), data)
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },
    GET_BY_ID_DRAFT: (id) => {
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.draft.GET_BY_ID_DRAFT(id))
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    },
    GET_BY_GMAILMSGID :(id)=>{
        return new Promise((resolve, reject) => {
            axios
                .get(process.env.REACT_APP_BACKEND_URL + api.draft.GET_BY_GMAILMSGID(id))
                .then((res) => resolve(res))
                .catch((err) => reject(err));
        });
    }

};
